export default {
	_init() {
		if ( ! this.options.Vue.axios ) {
			return "axios.js : Vue.axios must be set.";
		}
	},

	_interceptor( req, res ) {
		const me = this;

		if ( req ) {
			this.options.Vue.axios.interceptors.request.use( function( request ) {
				req.call( me, request );
				return request;
			}, function( error ) {
				req.call( me, error.request );
				return Promise.reject( error );
			} );
		}

		if ( res ) {
			this.options.Vue.axios.interceptors.response.use( function( response ) {
				res.call( me, response );
				return response;
			}, function( error ) {
				if ( error && error.response ) {
					res.call( me, error.response );
				}

				return Promise.reject( error );
			} );
		}
	},

	_invalidToken( res ) {
		if ( res && res.status === 401 ) {
			return true;
		}
	},

	_httpData( res ) {
		return res.data || {};
	},

	_http( data ) {
		const http = this.options.Vue.axios( data );

		http.then( data.success, data.error );

		return http;
	},

	_getHeaders( res ) {
		return res.headers;
	},

	_setHeaders( req, headers ) {
		req.headers.common = Object.assign( {}, req.headers.common, headers );
	}
};
